const { isIOS } = require('./videoElementUtils');
const {
  extractContentId,
  concatInitDataIdAndCertificate,
} = require('./drmUtils');

const SERVER_CERTIFICATE_PATH =
  'https://drm-ls.megogo.net/fairplay/cert.bin?ref=';
const SERVER_PROCESS_SPC_PATH = 'https://drm-ls.megogo.net/fairplay?ref=';

export function DRMInitializer(src, videoElement, certUrl, spcUrl, ref = '') {
  const certificatePath = certUrl ? certUrl : SERVER_CERTIFICATE_PATH + ref;
  const processSPCPath = spcUrl ? spcUrl : SERVER_PROCESS_SPC_PATH + ref;
  let certificate;
  let startPromiseResolve;
  let startPromiseReject;
  let certRequest;
  let spcRequest;

  this.start = () =>
    new Promise((resolve, reject) => {
      startPromiseResolve = resolve;
      startPromiseReject = reject;
      loadCertificate();
    });

  this.dispose = () => {
    videoElement.removeEventListener('webkitneedkey', onVideoNeedKey);
    startPromiseResolve = undefined;
    startPromiseReject = undefined;
    if (certRequest && certRequest.readyState !== 4) {
      certRequest.abort();
    }
    if (spcRequest && spcRequest.readyState !== 4) {
      spcRequest.abort();
    }
  };

  function makeSuccess() {
    if (typeof startPromiseResolve === 'function') {
      startPromiseResolve();
    }
  }

  function makeFail(message) {
    if (typeof startPromiseReject === 'function') {
      startPromiseReject(message);
    }
  }

  // 1
  function loadCertificate() {
    certRequest = new XMLHttpRequest();
    certRequest.responseType = 'arraybuffer';
    certRequest.open('GET', certificatePath, true);
    certRequest.setRequestHeader('Pragma', 'Cache-Control: no-cache');
    certRequest.setRequestHeader('Cache-Control', 'max-age=0');
    certRequest.send();
    certRequest.addEventListener('error', () => {
      makeFail('Failed to retrieve the server certificate.');
    });
    certRequest.addEventListener('load', () => {
      certificate = new Uint8Array(certRequest.response);
      startVideo();
    });
  }

  // 2
  function startVideo() {
    if (videoElement.src) {
      videoElement.src = '';
      videoElement.webkitSetMediaKeys(null);
    }
    videoElement.addEventListener('webkitneedkey', onVideoNeedKey);
    videoElement.src = src;
    if (isIOS()) {
      videoElement.play();
    }
  }

  // 3
  function onVideoNeedKey(event) {
    const video = event.target;
    const contentId = extractContentId(event.initData);
    const initData = concatInitDataIdAndCertificate(
      event.initData,
      contentId,
      certificate
    );

    if (
      window.WebKitMediaKeys.isTypeSupported('com.apple.fps.1_0', 'video/mp4')
    ) {
      video.webkitSetMediaKeys(new window.WebKitMediaKeys('com.apple.fps.1_0'));
    } else {
      makeFail('Key System not supported');
    }

    if (!video.webkitKeys) {
      makeFail('Could not create MediaKeys');
    }

    const keySession = video.webkitKeys.createSession('video/mp4', initData);
    if (!keySession) {
      makeFail('Could not create key session');
    }

    keySession.contentId = contentId;
    keySession.addEventListener('webkitkeymessage', onKeyMessage);
    // TODO: keySession.addEventListener('webkitkeyadded', () => {
    //   console.info('onKeyadded');
    //   makeSuccess();
    // });
    // keySession.addEventListener('webkitkeyerror', (event) => {
    //   makeFail('A decryption key error was encountered');
    // });
  }

  /*
	 MC: this function assumes the Key Server Module understands POST with plain SPC message bytes
	 */
  function onKeyMessage(event) {
    const session = event.target;
    const message = event.message;
    spcRequest = new XMLHttpRequest();
    spcRequest.responseType = 'arraybuffer';
    spcRequest.session = session;
    spcRequest.addEventListener('load', onLicenseRequestLoaded);
    spcRequest.addEventListener('error', () => {
      makeFail('The license request failed.');
    });
    spcRequest.open('POST', processSPCPath, true);
    spcRequest.setRequestHeader('Content-Type', 'application/octet-stream');
    spcRequest.send(message);
  }

  function onLicenseRequestLoaded(event) {
    // MC: response is plain CKC message bytes
    const request = event.target;
    const session = request.session;
    session.update(new Uint8Array(request.response));

    makeSuccess();
  }
}
